export const CardType = {
    CONPAY_CREDITO: { value: "CONPAY_CREDITO", labelKey: "conpay-credit" },
    CONPAY_DEBITO: { value: "CONPAY_DEBITO", labelKey: "conpay-debit" },
    CIELO: { value: "CIELO", labelKey: "cielo" },
    ACQIO_CREDITO: { value: "ACQIO_CREDITO", labelKey: "acqio-credit" },
    ACQIO_DEBITO: { value: "ACQIO_DEBITO", labelKey: "acqio-debit" },
};

export const ViolationCardPaymentStatus = {
  SIMULATION: { value: "Em Simulação", labelKey: "simulation" },
  FINALIZED: { value: "Finalizado", labelKey: "finalized" },
};

export const minParcels = 1;
export const maxParcels = 12;

export const ViolationDiscount = {
    ZERO: { value: "0", labelKey: "0" },
    TWENTY: { value: "20", labelKey: "20" },
    FORTY: { value: "40", labelKey: "40" },
};